/**
 * 智能客服 - 机器人过滤话术配置接口
 */
import { DEFAULT_PAGE_SIZE } from '@/constants/api';
import { apiGet, apiPost, apiPut } from '@/utils/request';
import { parsePaginatedResponse } from '@/utils/apiResponse';
import type {
  RobotFilterMessageConfigDetail,
  RobotFilterMessageConfigItem,
  RobotFilterMessageConfigPayload,
} from '@/types/robotFilterMessage';

/** 过滤话术配置：系统配置随列表返回一条，不提供增删改 */
export const robotFilterMessageConfigsApi = {
  list: (params: Record<string, unknown> = {}) =>
    apiGet('/robot-filter-message-configs', { page_size: DEFAULT_PAGE_SIZE, ...params }).then((d) =>
      parsePaginatedResponse<RobotFilterMessageConfigItem>(d),
    ),
  detail: (id: number) =>
    apiGet<RobotFilterMessageConfigDetail>(`/robot-filter-message-configs/${id}`),
  create: (data: RobotFilterMessageConfigPayload) => apiPost('/robot-filter-message-configs', data),
  update: (id: number, data: RobotFilterMessageConfigPayload) =>
    apiPut(`/robot-filter-message-configs/${id}`, data),
  updateEnabled: (id: number, status: number) =>
    apiPut(`/robot-filter-message-configs/${id}/enabled`, { status }),
  copy: (id: number) => apiPost(`/robot-filter-message-configs/${id}/copy`, {}),
};
